// Mock data for FourQ Learn landing page

export const testimonials = [
  {
    id: 1,
    name: "Priya Sharma",
    role: "Parent of Grade 8 Student",
    image: "https://images.unsplash.com/photo-1574758324765-a29c77fb9c91",
    text: "FourQ Learn has transformed my daughter's learning experience. Her grades improved significantly, and she actually enjoys her study sessions now!",
    rating: 5
  },
  {
    id: 2,
    name: "Rahul Verma",
    role: "Grade 10 Student",
    image: "https://images.unsplash.com/photo-1565598621680-94ac0c22b148",
    text: "The 1-on-1 sessions are amazing! My tutor explains everything clearly and I can ask questions without hesitation. Math is no longer scary!",
    rating: 5
  },
  {
    id: 3,
    name: "Anjali Patel",
    role: "Parent of Grade 5 Student",
    image: "https://images.unsplash.com/photo-1535295972055-1c762f4483e5",
    text: "The progress tracking feature gives me peace of mind. I can see exactly what my son is learning and how he's improving each week.",
    rating: 5
  },
  {
    id: 4,
    name: "Arjun Reddy",
    role: "Grade 12 Student",
    image: "https://images.unsplash.com/photo-1624486217002-846e654ac969",
    text: "FourQ Learn helped me ace my board exams! The flexible scheduling worked perfectly with my busy study routine.",
    rating: 5
  },
  {
    id: 5,
    name: "Meera Iyer",
    role: "Parent of Grade 6 Student",
    image: "https://images.unsplash.com/photo-1542810634-71277d95dcbb",
    text: "Best investment in my child's education. The tutors are professional, patient, and truly care about student success.",
    rating: 5
  }
];

export const benefits = [
  {
    id: 1,
    title: "1-on-1 Personalized Learning",
    description: "Every student learns differently. Our expert tutors adapt their teaching style to match your child's unique learning needs.",
    icon: "user"
  },
  {
    id: 2,
    title: "Expert Tutors for Every Subject",
    description: "Handpicked tutors with proven track records in Math, Science, English, and more. All subjects, all grades.",
    icon: "book"
  },
  {
    id: 3,
    title: "Progress Tracking for Parents",
    description: "Stay informed with detailed progress reports, session summaries, and real-time updates on your child's learning journey.",
    icon: "chart"
  },
  {
    id: 4,
    title: "Flexible Scheduling & Transparent Billing",
    description: "Book sessions at your convenience. Clear pricing with no hidden fees. Pay only for what you use.",
    icon: "calendar"
  }
];

export const howItWorks = [
  {
    id: 1,
    step: "Step 1",
    title: "Book a Free Session",
    description: "Schedule a complimentary trial session to experience our teaching methodology and meet potential tutors.",
    icon: "calendar-check"
  },
  {
    id: 2,
    step: "Step 2",
    title: "Get Matched with a Tutor",
    description: "We'll match you with the perfect tutor based on subject, grade level, and learning preferences.",
    icon: "user-check"
  },
  {
    id: 3,
    step: "Step 3",
    title: "Learn & Track Progress",
    description: "Attend interactive 1-on-1 sessions and watch your grades improve with our comprehensive progress tracking.",
    icon: "trending-up"
  }
];

export const features = {
  students: [
    {
      title: "Interactive Live Classes",
      description: "Engage in real-time video sessions with experienced tutors"
    },
    {
      title: "AI Quiz Assistant",
      description: "Practice with smart quizzes tailored to your learning level"
    },
    {
      title: "Gamified Learning",
      description: "Earn badges and rewards as you progress through lessons"
    },
    {
      title: "Doubt Resolution",
      description: "Ask questions anytime and get instant clarification"
    }
  ],
  parents: [
    {
      title: "Detailed Progress Reports",
      description: "Weekly updates on your child's learning milestones"
    },
    {
      title: "Consolidated Billing",
      description: "Transparent pricing with easy payment tracking"
    },
    {
      title: "Direct Tutor Communication",
      description: "Chat with tutors to discuss your child's progress"
    },
    {
      title: "Session Recordings",
      description: "Access recorded sessions for review anytime"
    }
  ],
  tutors: [
    {
      title: "Class Management Dashboard",
      description: "Organize and manage all your classes in one place"
    },
    {
      title: "Flexible Scheduling",
      description: "Set your availability and teach on your own schedule"
    },
    {
      title: "Earnings Dashboard",
      description: "Track your income with detailed earning reports"
    },
    {
      title: "Teaching Resources",
      description: "Access curated content and materials for effective teaching"
    }
  ]
};

export const stats = [
  {
    number: "1000+",
    label: "Happy Students"
  },
  {
    number: "100+",
    label: "Expert Tutors"
  },
  {
    number: "99%",
    label: "Satisfaction Rate"
  },
  {
    number: "50,000+",
    label: "Sessions Completed"
  }
];